import EventHandler from '../_dependencyvendor/event-handler';

const CANVAS_HEIGHT = 6;

class FillChart {
  constructor(element, options = { color: '#ccc', percent: 0 }) {
    this._element = element;
    this._options = {
      ...options,
    };
    this._canvas = null;
    this._ctx = null;
    this._init();
  }

  update(value) {
    this._options.percent = value;
    this._drawCanvas();
  }

  _init() {
    this._canvas = document.createElement('canvas');
    this._canvas.height = CANVAS_HEIGHT;
    this._ctx = this._canvas.getContext('2d');
    this._element.appendChild(this._canvas);
    this._initEvents();
    EventHandler.trigger(window, 'resize.chart-fill');
  }

  _initEvents() {
    EventHandler.on(window, 'resize.chart-fill', () => {
      this._canvas.width = this._element.getBoundingClientRect().width;
      this._drawCanvas();
    });
  }

  _drawCanvas() {
    const radius = 3;
    const resultWidth = this._canvas.width * (this._options.percent / 100);
    this._ctx.clearRect(0, 0, this._canvas.width, CANVAS_HEIGHT);
    this._ctx.fillStyle = '#f5f5f5';
    this._ctx.beginPath();
    this._ctx.moveTo(0 + radius, 0);
    this._ctx.arcTo(0 + this._canvas.width, 0, 0 + this._canvas.width, 0 + CANVAS_HEIGHT, radius);
    this._ctx.arcTo(0 + this._canvas.width, 0 + CANVAS_HEIGHT, 0, 0 + CANVAS_HEIGHT, radius);
    this._ctx.arcTo(0, 0 + CANVAS_HEIGHT, 0, 0, radius);
    this._ctx.arcTo(0, 0, 0 + this._canvas.width, 0, radius);
    this._ctx.closePath();
    this._ctx.fill();

    this._ctx.beginPath();
    this._ctx.fillStyle = this._options.color;
    this._ctx.moveTo(0 + radius, 0);
    this._ctx.arcTo(0 + resultWidth, 0, 0 + resultWidth, 0 + CANVAS_HEIGHT, radius);
    this._ctx.arcTo(0 + resultWidth, 0 + CANVAS_HEIGHT, 0, 0 + CANVAS_HEIGHT, radius);
    this._ctx.arcTo(0, 0 + CANVAS_HEIGHT, 0, 0, radius);
    this._ctx.arcTo(0, 0, 0 + resultWidth, 0, radius);
    this._ctx.closePath();
    this._ctx.fill();
  }
}

export default FillChart;
